export default {"src":"/login-app/[GIT_HASH]/_next/static/media/arrow_downward.36783d4e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};